import template from './user_permission_report.html';
import controller from './user_permission_report.controller';
import './user_permission_report.scss';

let userPermissionReportComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
};

export default userPermissionReportComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/user_permission_report/user_permission_report.component.js